/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycConsentEvidenceDto } from '../../models/kyc-consent-evidence-dto';

export interface UploadConsentEvidence$Params {
  processId: string;
      body?: {
'file': Blob;
}
}

export function uploadConsentEvidence(http: HttpClient, rootUrl: string, params: UploadConsentEvidence$Params, context?: HttpContext): Observable<StrictHttpResponse<KycConsentEvidenceDto>> {
  const rb = new RequestBuilder(rootUrl, uploadConsentEvidence.PATH, 'put');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycConsentEvidenceDto>;
    })
  );
}

uploadConsentEvidence.PATH = '/kyc/processes/{processId}/consent-evidence';
